const COUNTRY_CODE_TO_NAME = {
    ph: "Philippines",
    co: "Colombia",
};

export const getCountryNameByCode = (countryCode) => {
    const normalizedCode = String(countryCode || "").trim().toLowerCase();
    if (!normalizedCode) return "";

    return COUNTRY_CODE_TO_NAME[normalizedCode] || "";
};

export default COUNTRY_CODE_TO_NAME;
